import { UserProvider } from '@/contexts/UserContext';
import { ContentPageProvider } from '@netfront/ekardo-content-library';
import { LeftHandSideMenuProvider } from '../LeftHandSideMenu/LeftHandSidebarMenuProvider';
import { SmallScreenNavigationSideMenuProvider } from '../SmallScreenNavigationSideMenu/SmallScreenNavigationSideMenuProvider';
import ApolloClientsProvider from './ApolloClientsProvider';
import { NextStepProvider } from 'nextstepjs';

export default function Providers(props: React.PropsWithChildren) {
  return (
    <ApolloClientsProvider>
      <LeftHandSideMenuProvider>
        <SmallScreenNavigationSideMenuProvider>
          <UserProvider>
            <NextStepProvider>
              <ContentPageProvider>{props.children}</ContentPageProvider>
            </NextStepProvider>
          </UserProvider>
        </SmallScreenNavigationSideMenuProvider>
      </LeftHandSideMenuProvider>
    </ApolloClientsProvider>
  );
}
